/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * htoken API
 * OpenAPI spec version: v1
 */
export const CurrentPaymentDtoStatus = {
    SESSION_CREATED: 'SESSION_CREATED',
    SESSION_FINISHED: 'SESSION_FINISHED',
    AUTHORISED: 'AUTHORISED',
    REFUNDED: 'REFUNDED',
    CANCELLED: 'CANCELLED',
    FAILED: 'FAILED',
};
//# sourceMappingURL=currentPaymentDtoStatus.js.map